import { Component, Input, OnInit } from '@angular/core';
import { ProductCategory } from '../../models/product-category';
import { faArrowCircleRight, faLevelUpAlt } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-product-category',
  templateUrl: 'product-category.component.html',
  styleUrls: ['product-category.component.css'],
})
export class ProductCategoryComponent implements OnInit {
  @Input() productCategory: ProductCategory;

  faArrowCircleRight = faArrowCircleRight;
  faLevelUpAlt = faLevelUpAlt;

  constructor(
  ) {
  }

  ngOnInit() {
  }

}
